import { useRecordContext } from "react-admin";
import { Chip } from "@mui/material";
import { SEVERITY_CHOICES } from "../consts";

const SeverityChipField = ({
  source,
  resource,
}: {
  source: string;
  resource?: string;
}) => {
  const record = useRecordContext();
  const severity = record?.[source];

  const getColor = () => {
    if (resource === "rmf/risks") {
      if (severity === "catastrophic") return "#D32F2F";
      if (severity === "extremely_high") return "#D32F2F";
      if (severity === "frequent") return "#D32F2F";

      if (severity === "critical") return "#F57C00";
      if (severity === "high") return "#F57C00";
      if (severity === "likely") return "#F57C00";

      if (severity === "medium") return "#FBC02D";
      if (severity === "moderate") return "#FBC02D";
      if (severity === "occasional") return "#FBC02D";

      if (severity === "low") return "#FFF176";
      if (severity === "negligible") return "#FFF176";
      if (severity === "seldom") return "#FFF176";
    } else {
      if (severity === "critical") return "#D32F2F";
      if (severity === "high") return "#F57C00";
      if (severity === "medium") return "#FBC02D";
      if (severity === "low") return "#FFF176";
    }
    return "#BDBDBD";
  };

  const getDisplayName = () => {
    const choice = SEVERITY_CHOICES.find((choice) => choice.id === severity);
    return (choice?.name || severity).toUpperCase();
  };

  if (!severity) return null;

  return (
    <Chip
      label={getDisplayName()}
      sx={{
        backgroundColor: getColor(),
        color: "black",
        fontWeight: "bold",
        padding: "0",
        margin: "0",
        borderRadius: "1em",
        height: "1.5em",
        width: resource === "rmf/risks" ? "auto" : "7em",
      }}
    />
  );
};

export default SeverityChipField;
